import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "progress-bar-steps";

const ProgressBarSteps = ({
  data,
  step,
  setStep,
  step_touched,
  isResult,
  hiddenMobileSteps = [],
}) => {
  const { t } = useTranslation();
  const { max, min } = useResponsive();

  const visibleSteps = (data || [])
    .map((label, index) => ({ label, index }))
    .filter(({ index }) => !max.sm || !hiddenMobileSteps.includes(index));
  const mobileStep = Math.max(
    0,
    visibleSteps.filter(({ index }) => index <= step).length - 1,
  );

  return (
    <div className={mainClass}>
      {max.sm && (
        <div className={`${mainClass}__progress`}>
          <p>
            <span>{`${t("Step")} ${mobileStep + 1}/${visibleSteps.length}`}</span>{" "}
            <strong>{visibleSteps[mobileStep]?.label}</strong>
          </p>
        </div>
      )}
      <span className={`${mainClass}__steps`}>
        {visibleSteps.map(({ label, index }) => (
          <div
            key={index}
            onClick={
              !isResult
                ? () => (step_touched >= index ? setStep(index) : {})
                : undefined
            }
            className={classnames(`${mainClass}__steps__item`, {
              [`${mainClass}__steps__item--active`]: step >= index,
              [`${mainClass}__steps__item--finished`]: step > index,
              [`${mainClass}__steps__item--touched`]:
                step_touched >= index && !isResult,
            })}
          >
            {min.sm && <small>{label}</small>}
          </div>
        ))}
      </span>
    </div>
  );
};

export default ProgressBarSteps;
